<div class="notification with-icon custom-position-notification" [ngClass]="state" role="alert"
     aria-labelledby="notification-title" id="notification" #notification>
  <h2 id="notification-title" class="h5 ">

    @switch (state) {
      @case ('info') {
        <app-icon name="info-circle"/>
      }
      @case ('error') {
        <app-icon name="close-circle"/>
      }
      @case ('warning') {
        <app-icon name="error"/>
      }
      @case ('success') {
        <app-icon name="check-circle"/>
      }
    }
    <span>{{ message }}</span>
  </h2>
</div>
